import {Component, Input, Output, EventEmitter, HostBinding} from '@angular/core';

@Component({
    selector: 'table-panel',
    templateUrl: './table-panel.component.html',
    styleUrls: ['./table-panel.component.scss'],
})
export class CustomTablePanelComponent {

    @Input() header: string = null;
    @Input() saveDisabled = false;
    @Input() newOneTitle: string;
    @Input() compTableFlag = false;

    @Output() createNewOne: EventEmitter<any> = new EventEmitter();
    @Output() componentReset: EventEmitter<any> = new EventEmitter();

    createNew() {
        this.createNewOne.emit();
    }

    reset() {
        this.componentReset.emit();
    }
}
